import { getSelfOrNearestAncestorByClassName } from "../utils/dom";
import { ImprezaTestDriveBannerStatus } from "../eventsStatus/index";
declare const ModelName; //Declared on window
import each from "lodash/each";

const PromoBar = () => {
  const pbClose = document.querySelectorAll(".promoBar__close");
  each(pbClose, btn => {
    btn.addEventListener("click", e => {
      e.preventDefault();
      const parent = getSelfOrNearestAncestorByClassName(btn, "promoBar");
      parent && parent.classList.remove("promoBar--onNow");
      document.getElementsByTagName("body")[0].classList.remove("has-promoBar");
    });
  });

  const pbImprezaTestDrive = document.getElementById("pbImprezaTestDrive");
  if (pbImprezaTestDrive && ImprezaTestDriveBannerStatus.isOnNow && ImprezaTestDriveBannerStatus.appliesToModel(ModelName)) {
    pbImprezaTestDrive.classList.add("promoBar--onNow");
    document.getElementsByTagName("body")[0].classList.add("has-promoBar");
    console.log;
    return;
  }
};

export default PromoBar;
